import axios from 'axios';
import { getAuthHeaders } from '../Auth';
import config from '../config';

const host = config.backendServiceUrl;
const basePath = '/api/v3/inspiration:editImage';
export interface EditImageInput {
    prompt: string;
    description?: string;
    imageUrl: string;
    model?: string;
    signal: AbortSignal;
}

export const postEditImage = async ({
    prompt,
    description,
    imageUrl,
    model,
    signal,
}: EditImageInput): Promise<string> => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${host}${basePath}`,
            {
                prompt,
                description: description || '',
                imageUrl,
                ...(model && { model }),
            },
            {
                signal,
                headers,
            },
        );

        if (!response.data) {
            throw new Error('Empty response from API');
        }

        if (!response.data.imageUrl) {
            console.error('API Response:', response.data);
            throw new Error('API response missing imageUrl field');
        }

        return response.data.imageUrl;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('API Error:', error.response?.data || error.message);
            throw new Error(`API request failed: ${error.response?.data?.message || error.message}`);
        }
        console.error('Error editing image:', error);
        throw error;
    }
};
